import { useState } from 'react';
// import { Link } from 'react-router-dom'; // Hidden: View Details button
import { draftingServices } from '../../../mocks/draftingServices';
import RequestQuotePopup from '../../../components/feature/RequestQuotePopup';

export default function DraftingServices() {
  const [selectedService, setSelectedService] = useState<number | null>(null);
  const [quoteService, setQuoteService] = useState<string | null>(null);

  return (
    <>
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-orange-50 text-[#e18033] px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-pencil-ruler-2-line"></i>
              <span>12+ Specialized Services</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Comprehensive Drafting Solutions
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              From architectural plans to MEP systems, we provide complete drafting services for every aspect of your construction project
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {draftingServices.map((service) => (
              <div
                key={service.id}
                className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer group"
                onClick={() => setSelectedService(selectedService === service.id ? null : service.id)}
              >
                <div className="relative h-64 w-full overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg">
                    <i className={`${service.icon} text-2xl text-[#e18033]`}></i>
                  </div>
                  {/* Disclaimer badge with tooltip */}
                  {service.disclaimer && (
                    <div className="absolute bottom-3 right-3 group/disclaimer z-10" onClick={(e) => e.stopPropagation()}>
                      <div className="flex items-center gap-1.5 px-2.5 py-1 bg-amber-500/90 text-white text-[11px] font-semibold rounded-full cursor-help shadow-md backdrop-blur-sm">
                        <i className="ri-error-warning-line text-xs" />
                        {service.disclaimer.label}
                      </div>
                      {/* Tooltip */}
                      <div className="absolute bottom-full right-0 mb-2 w-60 px-3 py-2.5 bg-[#212026] text-white text-xs leading-relaxed rounded-xl shadow-xl opacity-0 group-hover/disclaimer:opacity-100 pointer-events-none transition-opacity duration-200 z-20">
                        {service.disclaimer.description}
                        <div className="absolute top-full right-4 w-2.5 h-2.5 bg-[#212026] rotate-45 -mt-1.5" />
                      </div>
                    </div>
                  )}
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#e18033] transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                    {service.description}
                  </p>

                  <div className="flex flex-wrap gap-2 mb-4">
                    {service.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>

                  <div className="mt-auto pt-4 border-t border-gray-50">
                    {/* View Details button hidden for now
                    <Link
                      to={`/service/${service.title.toLowerCase().replace(/\s+/g, '-').replace(/[&/]/g, '')}`}
                      className="inline-flex items-center justify-center px-6 py-3 rounded-lg font-semibold border-2 border-[#e18033] text-[#e18033] hover:bg-orange-50 transition-colors cursor-pointer text-sm w-full sm:w-auto"
                    >
                      View Details
                      <i className="ri-arrow-right-line ml-2"></i>
                    </Link>
                    */}
                    <button
                      onClick={() => setQuoteService(service.title)}
                      className="inline-flex items-center text-[#e18033] font-semibold text-sm group/btn cursor-pointer hover:text-[#c97029] transition-colors"
                    >
                      Request Quote
                      <i className="ri-arrow-right-line ml-2 transition-transform group-hover/btn:translate-x-1"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Request Quote Popup */}
      <RequestQuotePopup
        isOpen={!!quoteService}
        onClose={() => setQuoteService(null)}
        serviceName={quoteService || undefined}
      />
    </>
  );
}
